import type { TrackedActionsType } from './trackedActions';
import { tracker } from './tracker';
import { useTrackingContext } from './useTrackingContext';

export const useTrackEvent = () => {
  const trackingContext = useTrackingContext();

  return (name: TrackedActionsType, properties?: Record<string, unknown>) => {
    if (!tracker.user?.()?.id()) return;

    return tracker.track(name, {
      ...trackingContext,
      ...properties,
    });
  };
};
